module.exports = __webpack_public_path__ + "static/media/clients.b88ed2d5.svg";